(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  function initializeFooterNewsletterModal(sectionElement) {
    const modal = document.querySelector('.l-newsletterModal');
    if (!modal) {
      console.error('Newsletter modal not found');
      return;
    }

    // モーダルを開くボタンはセクション内から検索
    const openButton = sectionElement.querySelector('.js-newsletter-modal-open');
    const closeButton = modal.querySelector('.l-newsletterModal__close');
    const modalBg = modal.querySelector('.l-newsletterModal__bg');

    // 要素の存在チェックを強化
    if (!openButton) {
      console.error('Open button (.js-newsletter-modal-open) not found in section:', sectionElement);
      return;
    }
    if (!closeButton) {
      console.error('Close button (.l-newsletterModal__close) not found in modal:', modal);
      return;
    }
    if (!modalBg) {
      console.error('Modal background (.l-newsletterModal__bg) not found in modal:', modal);
      return;
    }

    function openModal() {
      modal.classList.add('is-active');
    }

    function closeModal() {
      modal.classList.remove('is-active');
    }

    // イベントリスナーの設定は要素が存在する場合のみ行う
    if (openButton) {
      openButton.removeEventListener('click', openModal);
      openButton.addEventListener('click', openModal);
    }

    if (closeButton) {
      closeButton.removeEventListener('click', closeModal);
      closeButton.addEventListener('click', closeModal);
    }

    if (modalBg) {
      modalBg.removeEventListener('click', closeModal);
      modalBg.addEventListener('click', closeModal);
    }
  }

  function initializeThankYouModal() {
    const thankyouModal = document.querySelector('.l-thankyouModal');
    if (!thankyouModal) {
      console.error('Thank you modal not found');
      return;
    }
    const closeButton = thankyouModal.querySelector('.l-thankyouModal__close');
    const modalBg = thankyouModal.querySelector('.l-thankyouModal__bg');
    const button = thankyouModal.querySelector('.l-thankyouModal__button');

    if (!closeButton) {
      console.error('Close button (.l-thankyouModal__close) not found in thank you modal:', thankyouModal);
    }
    if (!modalBg) {
      console.error('Modal background (.l-thankyouModal__bg) not found in thank you modal:', thankyouModal);
    }
    if (!button) {
      console.error('Button (.l-thankyouModal__button) not found in thank you modal:', thankyouModal);
    }

    function closeModal() {
      thankyouModal.classList.remove('is-active');
    }

    if (closeButton) {
      closeButton.removeEventListener('click', closeModal);
      closeButton.addEventListener('click', closeModal);
    }
    if (modalBg) {
      modalBg.removeEventListener('click', closeModal);
      modalBg.addEventListener('click', closeModal);
    }
    if (button) {
      button.removeEventListener('click', closeModal);
      button.addEventListener('click', closeModal);
    }
    // 初期表示時に閉じるイベントリスナーを設定するために一度呼び出す
    if (thankyouModal.classList.contains('is-active')) {
      // モーダルがアクティブな場合のみイベントリスナーを設定する
    }
  }

  function setupEventListeners() {
    const currentSectionElement = document.getElementById('shopify-section-{{ section.id }}');
    if (currentSectionElement) {
      // ニュースレターボタンが存在する場合のみ初期化
      if (currentSectionElement.querySelector('.js-newsletter-modal-open')) {
        initializeFooterNewsletterModal(currentSectionElement);
      }
      initializeThankYouModal(); // セクションロード時にもありがとうモーダルの初期化を行う
    } else {
      const fallbackFooterElement = document.querySelector('footer.l-footer');
      if (fallbackFooterElement && fallbackFooterElement.closest('.shopify-section')) {
        const sectionElement = fallbackFooterElement.closest('.shopify-section');
        if (sectionElement.querySelector('.js-newsletter-modal-open')) {
          initializeFooterNewsletterModal(sectionElement);
        }
      } else if (fallbackFooterElement) {
        if (fallbackFooterElement.querySelector('.js-newsletter-modal-open')) {
          initializeFooterNewsletterModal(fallbackFooterElement);
        }
      } else {
        console.error('Footer section element not found for initialization.');
      }
    }

    // URLパラメータをチェックしてモーダルを表示するロジックをここに追加
    const urlParams = new URLSearchParams(window.location.search);
    const customerPosted = urlParams.get('customer_posted');

    if (customerPosted === 'true') {
      const newsletterModal = document.querySelector('.l-newsletterModal');
      if (newsletterModal) {
        newsletterModal.classList.remove('is-active');
      }
      const thankyouModal = document.querySelector('.l-thankyouModal');
      if (thankyouModal) {
        thankyouModal.classList.add('is-active');
        // initializeThankYouModal はモーダル表示後に呼び出すことで、
        // 表示されたモーダルに対して確実にイベントリスナーが設定される
        if (typeof initializeThankYouModal === 'function') {
          initializeThankYouModal();
        }
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupEventListeners);
  } else {
    setupEventListeners();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.id === 'shopify-section-{{ section.id }}') {
      // ニュースレターボタンが存在する場合のみ初期化
      if (event.target.querySelector('.js-newsletter-modal-open')) {
        initializeFooterNewsletterModal(event.target);
      }
      initializeThankYouModal(); // セクションロード時にもありがとうモーダルの初期化を行う
    }
  });

  const btn = document.getElementById('scrollToTopBtn');
  if (btn) {
    const progressCircle = btn.querySelector('.progress');
    const radius = 19; // r="19"
    const circumference = 2 * Math.PI * radius; // 約119.38
    const footer = document.querySelector('footer');

    function setProgress(percent) {
      const offset = circumference * (1 - percent);
      progressCircle.style.strokeDashoffset = offset;
    }

    window.addEventListener('scroll', () => {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const percent = docHeight ? scrollTop / docHeight : 0;

      setProgress(percent);

      if (scrollTop > 100) {
        btn.classList.add('show');
      } else {
        btn.classList.remove('show');
      }

      // フッターの現在の位置情報を取得
      const footerRect = footer.getBoundingClientRect();

      // ビューポートの高さ
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;

      // フッターがビューポートに入ったかどうかを判定
      // footerRect.top がビューポートの高さ以下、かつ
      // footerRect.bottom が 0 より大きい場合（フッターが見えている状態）
      const isFooterVisible = footerRect.top < viewportHeight && footerRect.bottom > 0;

      if (isFooterVisible) {
        btn.classList.remove('show');
      } else {
        btn.classList.add('show');
      }
    });

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    // 初期化
    setProgress(0);
  }

// フッターのジェンダーリンククリック時のCookie設定
document.addEventListener('DOMContentLoaded', function() {
  var footerGenderLinks = document.querySelectorAll('.l-footer__menu-box a[data-gender]');
  
  footerGenderLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      var gender = this.getAttribute('data-gender');
      
      // Cookieにジェンダー状態を保存
      function setCookie(name, value, days) {
        var expires = "";
        if (days) {
          var date = new Date();
          date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
          expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + value + expires + "; path=/";
      }
      
      setCookie('selected_gender', gender, 30);
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
